module["exports"] = ["/5[1-5]##-####-####-###L/", "/6771-89##-####-###L/"];